import { render } from "./ExpandComponent.vue?vue&type=template&id=68f5f988&scoped=true"
import script from "./ExpandComponent.vue?vue&type=script&lang=js"
export * from "./ExpandComponent.vue?vue&type=script&lang=js"

import "./ExpandComponent.vue?vue&type=style&index=0&id=68f5f988&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f5f988"]])

export default __exports__